import { createApi } from "@reduxjs/toolkit/query/react";

import { TagType } from "../enums";
import { documentApiBaseQuery } from "./documentApiBaseQuery";

export const documentApi = createApi({
  reducerPath: "documentApi",
  baseQuery: documentApiBaseQuery({
    // Fill in your own server starting URL here
    baseUrl: window.REACT_APP_INQUIRY_API,
  }),
  endpoints: () => ({}),
  tagTypes: Object.values(TagType),
});
